// LICENSE_CODE ZON
/*jslint browser:true, es6:true, node:true, react:true*/
import React from 'react';
import {use_theme} from '../../../../hola/pub/settings_ctx';
import {Form, Login_banner} from '../login/form';

interface i_show_login_form_opt {
    no_close?: boolean;
    no_overlay_close?: boolean;
    back_to_prev_page?: boolean;
    signup_title?: string;
    signup_subtitle?: string;
}

export const use_login = (cp_after_login?: boolean, cp_link?: string)=>{
    const {show_modal} = use_theme();
    // eslint-disable-next-line
    const show_login_form = (default_state?: string,
        opt: i_show_login_form_opt = {})=>{
        const {no_close, no_overlay_close, back_to_prev_page, signup_title,
            signup_subtitle} = opt;
        const login_props = {
            Banner: <Login_banner/>,
            can_signup: true,
            next: cp_after_login ? cp_link || '/cp' : undefined,
            default_state: default_state || 'login_buttons',
            img_set: 'toolip',
            support_email: 'support@oculusproxies.com',
            blocks: {
                social: {
                    hide_fb: true,
                    hide_apple: true,
                    hide_github: true,
                },
            },
            back_to_prev_page,
            signup_title,
            signup_subtitle,
        };
        show_modal('login_form', p=><Form {...p} {...login_props}/>, {
            width: 768,
            paddingless: true,
            no_logo: true,
            mobile_full_height: true,
            no_close,
            ...no_overlay_close ? {on_overlay_click: ()=>null} : null,
        });
    };

    const on_login = event=>{
        event.preventDefault();
        show_login_form();
    };
    const on_signup = event=>{
        event.preventDefault();
        show_login_form('signup_buttons');
    };
    return {
        on_login, on_signup, show_login_form,
    };
};
